import ForgotPasswordForm from '../../../components/Home/ForgotPasswordForm/ForgotPasswordForm'

const ForgotPassword = () => {
  return (
      <ForgotPasswordForm />
  )
}

export default ForgotPassword